import { render, staticRenderFns } from "./TabbedDynamicForm.vue?vue&type=template&id=465d3b72&"
import script from "./TabbedDynamicForm.vue?vue&type=script&lang=ts&"
export * from "./TabbedDynamicForm.vue?vue&type=script&lang=ts&"
import style0 from "./TabbedDynamicForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
